import Vue from "vue";
import routes from "@/routes";
import VueAuthenticate from "vue-authenticate";
import api from "../api";
import store from "@/store";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

const vueAuth = new VueAuthenticate.factory(Vue.prototype.$http, {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  tokenName: "access_token",
  loginUrl: "/login",
  registerUrl: "/register",
});

export default {
  state: {
    isAuthenticated: false,
    vuexInitialState: null,
    user: [],
    permissions: [],
    theme_mode: "light",
    notifications: [],
  },

  getters: {
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
    vuexInitialState(state) {
      return state.vuexInitialState;
    },
    permissions(state) {
      return state.permissions;
    },
    user(state) {
      return state.user;
    },
    theme_mode(state) {
      return state.theme_mode;
    },
    notifications(state) {
      return state.notifications;
    }
  },

  mutations: {
    isAuthenticated(state, payload) {
      state.isAuthenticated = payload.isAuthenticated;
    },
    SET_VUEX_INITIAL_STATE(state, payload) {
      state.vuexInitialState = payload.vuexInitialState;
    },
    RESET_VUEX_INITIAL_STATE() {
      let vuexInitialState = store.getters["vuexInitialState"];
      if (vuexInitialState == null) {
        localStorage.clear();
        return;
      }

      store.replaceState(vuexInitialState);
    },
    SET_PERMISSIONS(state, payload) {
      state.permissions = payload;
    },
    SET_USER(state, payload) {
      state.user = payload;
    },
    SET_THEME_MODE(state, payload) {
      state.theme_mode = payload;
    },
    SET_NOTIFICATIONS(state, payload) {
      state.notifications = payload;
    },
  },

  actions: {
    async login(context, payload) {
      return axios
        .get(api.sanctumCookie, { withCredentials: true })
        .then(async () => {
          let route =
            payload.login_type === "employee"
              ? api.login_employee
              : api.login_customer;
          return axios
            .post(route, payload.user, payload.requestOptions)
            .then((response) => {
              context.commit("isAuthenticated", {
                isAuthenticated: true,
              });
              context.commit("SET_USER", response.data.user);
              context.commit(
                "SET_PERMISSIONS",
                response.data.user.roles[0].permissions
              );
              this.dispatch("getNotifications");
              routes.push({ name: "Dashboard" });
            });
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    register(context, payload) {
      return vueAuth
        .register(payload.user, payload.requestOptions)
        .then((response) => {
          context.commit("isAuthenticated", {
            isAuthenticated: vueAuth.isAuthenticated(),
          });
          routes.push({ name: "Home" });
        });
    },
    async logout({ dispatch }) {
      return axios
        .post(api.logout, {})
        .then(async () => {
          dispatch("logout_vuex");
        })
        .catch(async (error) => {
          dispatch("logout_vuex");
        });
    },
    async logout_vuex({ commit }) {
      await commit("isAuthenticated", {
        isAuthenticated: false,
      });
      await commit("RESET_VUEX_INITIAL_STATE");
      await routes.push({ name: "Login" });
    },
    async getCustomers({ _ }) {
      return axios
        .get(api.customers)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return [];
        });
    },
    async getDashboardData({ _ }) {
      return axios
        .get(api.dashboard)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return [];
        });
    },
    async getBanners({ _ }) {
      return axios
        .get(api.banners)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return [];
        });
    },
    async forgotPassword({ _ }, email) {
      return axios
        .get(api.sanctumCookie, { withCredentials: true })
        .then(async () => {
          store.dispatch("alerts/success", "Enviando e-mail...");
          axios
            .post(api.forgot_password, { email })
            .then(async (response) => {
              store.dispatch("alerts/success", response.data.msg);
              await routes.push({ name: "Login" });
              return response.data;
            })
            .catch((error) => {
              return Promise.reject(error);
            });
        });
    },
    async resetPassword({ _ }, payload) {
      return axios
        .get(api.sanctumCookie, { withCredentials: true })
        .then(async () => {
          store.dispatch("alerts/success", "Alterando senha...");
          axios
            .post(api.reset_password, payload)
            .then(async (response) => {
              store.dispatch("alerts/success", response.data.msg);
              await routes.push({ name: "Login" });
              return response.data;
            })
            .catch((error) => {
              return Promise.reject(error);
            });
        });
    },
    async getNotifications(context) {
      axios
        .get(api.notifications)
        .then((response) => {
          context.commit("SET_NOTIFICATIONS", response.data.data);
        })
    },
    readNotification(context, id) {
      context.commit("SET_NOTIFICATIONS", context.state.notifications.filter(n => n.id != id));
      axios
        .delete(`${api.notifications}/${id}`)
        .finally(() => {
          axios
            .get(api.notifications)
            .then((response) => {
              context.commit("SET_NOTIFICATIONS", response.data.data);
            })
        })
    },
    readAllNotification(context) {
      axios
        .delete(`${api.notifications}`)
        .catch(() => {
          Promise.reject();
        })
        .finally(() => {
          axios
            .get(api.notifications)
            .then((response) => {
              context.commit("SET_NOTIFICATIONS", response.data.data);
            })
        })
    }
  },
};
